var header = {

    settings: {
        header: $('.header-main'),
        scroll_pos: 0,
    },

    init: function() {
        header.bindUIActions();
        header.scrollHandler();
    },

    bindUIActions: function() {
        // On scroll
        $(window).on('scroll', global_helpers.debounce(header.scrollHandler, 100));

        this.settings.header.hoverIntent({
            over: function() {
                
            },
            out: function() {
                $(this).removeClass('hovering');
            },
            interval: 200,
            sensitivity: 10,
            timeout: 600,
        });

        this.settings.header.find('.main-menu > .menu-item-has-children').hoverIntent({
            over: function() {
                $(this).addClass('hovering');
                header.settings.header.addClass('hovering');
            },
            out: function() {
                $(this).removeClass('hovering');
            },
            interval: 200,
            sensitivity: 10,
            timeout: 600,
        });

    },

    scrollHandler: function() {
        // Get the current scroll position
        var scroll = $(window).scrollTop();

        if (scroll >= header.settings.scroll_pos && scroll >= 100) {
            header.settings.header.addClass('sticky-header');
        } else if (scroll <= 100) {
            header.settings.header.removeClass('sticky-header');
        }
        // Store the new value
        header.settings.scroll_pos = scroll;
    },

}
header.init();


// Toggle mobile menu
$('.header-main .hamburger').on('click', function() {
    if (!$('.header-main').hasClass('mobile-menu-open')) {
        $('.header-main').addClass('mobile-menu-open');
        $('body').addClass('no-scroll');
    } else {
        $('.header-main').removeClass('mobile-menu-open');
        $('body').removeClass('no-scroll');
        $('.header-main').find('.submenu-open').removeClass('submenu-open');
        $('.header-main').find('.active').removeClass('active');
    }
});

// Trigger child and grandchild page flyouts
$('.header-main .main-menu li.menu-item-has-children').on('click', (e) => {
    $(e.currentTarget).closest('.main-menu').addClass('submenu-open');
    $(e.currentTarget).addClass('active');
});

// Prevent clicks on actual menu links from triggering panel flyouts
$('.header-main .main-menu li.menu-item > a').on('click', (e) => {
    e.stopPropagation();
    e.stopImmediatePropagation();
});

// Trigger menu 'back' functionality
$('.header-main .main-menu .submenu-back-btn').on('click', (e) => {
    e.stopPropagation();
    $(e.currentTarget).closest('.submenu-open').removeClass('submenu-open').find('.active').removeClass('active');
});

// Swap menu item images on hover
$('.header-main .js-has-image').on('mouseenter', function() {
    // Reset images
    $(this).closest('.submenu-primary-container').find('.menu-item-images img').removeClass('active');
    // Activate hovered item
    $(this).closest('.submenu-primary-container').find('[data-menu-item-image="' + $(this).data('menu-item-image-target') + '"]').addClass('active');
});

// Reset featured image on menu closing
$('.header-main').on('mouseleave', function() {
    // Reset images
    $(this).find('.menu-item-images img').removeClass('active');
});